import { makeStyles, Button, LoadingButton, TextField, FormControl, Collapse } from 'beam'
import { Fragment, ReactElement, useState, ChangeEvent, KeyboardEvent } from 'react'
import { useTranslation } from 'react-i18next'
import ForgotPassword from './ForgotPassword'
import TenantSelection from './TenantSelection'
import { ForgotPasswordResult } from '../app.reducer'
import { TenantSummary } from './login.api'
interface LoginFormProps {
  loginError: string,
  singleSignOnError: string,
  tenants: TenantSummary[],
  onConfirmForgotPassword: $TSFIXME,
  forgotPasswordResult: ForgotPasswordResult | null,
  onLogin: $TSFIXME,
  onSingleSignOn: $TSFIXME,
}

const useStyles = makeStyles(theme => ({
  loginBox: {
    padding: theme.spacing(2, 5),
    minWidth: theme.spacing(65),
  },
  textField: {
    display: 'block',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
  },
  buttonContainerItem: {
    display: 'inline-block',
  },
  button: {
    marginLeft: theme.spacing(1),
  },
  forgotPasswordButton: {
    // TODO:
  },
}))

const LoginBox = (props: LoginFormProps): ReactElement => {
  const { t } = useTranslation()
  const classes = useStyles()

  const {
    loginError,
    singleSignOnError,
    tenants,
    onConfirmForgotPassword,
    forgotPasswordResult,
    onLogin,
    onSingleSignOn,
  } = props

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [tenant, setTenant] = useState<number | string>('')
  const [showDialog, setShowDialog] = useState(false)
  const [loginRequested, setLoginRequested] = useState(false)

  const updateUsername = (event: ChangeEvent<HTMLInputElement>): void => {
    setUsername(event.target.value)
  }

  const updatePassword = (event: ChangeEvent<HTMLInputElement>): void => {
    setPassword(event.target.value)
  }

  const handleKeyPress = (event: KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === 'Enter') {
      handleLogin()
    }
  }

  const handleLogin = (): void => {
    if (username) {
      if (password) {
        setLoginRequested(true)
        onLogin(username, password, tenant)
      }
    } else {
      setLoginRequested(true)
      onSingleSignOn(username, tenant)
    }
  }

  const handleSingleSignOn = (): void => {
    onSingleSignOn(username, tenant)
  }

  const selectTenant = (tenant: number): void => {
    setTenant(tenant)
    setLoginRequested(false)
  }

  const handleForgotPassword = (): void => {
    setShowDialog(true)
  }

  const hideForgotPassword = (): void => {
    setShowDialog(false)
  }

  return (
    <Fragment>
      <form>
        <FormControl fullWidth onKeyPress={handleKeyPress}>
          {/* <FieldContainer> */}
          <TextField
            error={Boolean(singleSignOnError)}
            helperText={singleSignOnError}
            label={t('username')}
            className={classes.textField}
            onChange={updateUsername}
            fullWidth
            // margin="normal"
            inputProps={{
              'auto-qa-id': 'LoginForm-input-username',
              'data-testid': 'LoginForm-input-username',
            }}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- TODO: remove this eslint-disable and fix the types to allow 'data-testid'
            // @ts-expect-error
            FormHelperTextProps={{ 'data-testid': 'LoginForm-username-helperText' }}
          />
          <TextField
            error={Boolean(loginError)}
            helperText={loginError}
            label={t('password')}
            className={classes.textField}
            type="password"
            autoComplete="current-password"
            onChange={updatePassword}
            fullWidth
            // margin="normal"
            inputProps={{
              'auto-qa-id': 'LoginForm-input-password',
              'data-testid': 'LoginForm-input-password',
            }}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- TODO: remove this eslint-disable and fix the types to allow 'data-testid'
            // @ts-expect-error
            FormHelperTextProps={{ 'data-testid': 'LoginForm-password-helperText' }}
          />
          <Collapse in={tenants.length > 0} timeout="auto" unmountOnExit>
            {tenants.length > 0 && <TenantSelection tenant={tenant} tenants={tenants} onChange={selectTenant} />}
          </Collapse>
          {/* </FieldContainer> */}
        </FormControl>
        <div className={classes.buttonContainer}>
          <div className={classes.buttonContainerItem}>
            <Button
              className={classes.forgotPasswordButton}
              onClick={handleForgotPassword}
              auto-qa-id={'LoginForm-button-forgotPassword'}
              data-testid={'LoginForm-button-forgotPassword'}
            >
              {t('forgotPassword')}
            </Button>
          </div>
          <div className={classes.buttonContainerItem}>
            <LoadingButton
              color="secondary"
              className={classes.button}
              variant="contained"
              disabled={!username || !password || (loginRequested && !loginError)}
              onClick={handleLogin}
              loading={loginRequested && !loginError}
              auto-qa-id={'LoginForm-button-login'}
              data-testid={'LoginForm-button-login'}
              aria-label={t('login')}
            >
              {t('login')}
            </LoadingButton>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              disabled={!username}
              onClick={handleSingleSignOn}
              auto-qa-id={'LoginForm-button-singleSignOn'}
              data-testid={'LoginForm-button-singleSignOn'}
            >
              {t('singleSignOn')}
            </Button>
          </div>
        </div>
      </form>
      <ForgotPassword
        open={showDialog}
        onClose={hideForgotPassword}
        onConfirm={onConfirmForgotPassword}
        forgotPasswordResult={forgotPasswordResult}
      />
    </Fragment>
  )
}

export default LoginBox
